import { config } from 'cfg'

export const ROAD_WORKS_ENDPOINTS = {
  ROAD_WORKS: () => `${config.apiBaseUrl}/roadworks`
}
